import { render, staticRenderFns } from "./LayoutTabbed.vue?vue&type=template&id=0385e03e&scoped=true"
import script from "./LayoutTabbed.vue?vue&type=script&lang=js"
export * from "./LayoutTabbed.vue?vue&type=script&lang=js"
import style0 from "./LayoutTabbed.vue?vue&type=style&index=0&id=0385e03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385e03e",
  null
  
)

export default component.exports